module.exports = __webpack_public_path__ + "img/worldsbestpedagogy.3806ba9c.png";